import DataPill from "@components/pills/DataPill";
import React from "react";

interface StatusPillOfframpChargeManagementProps {
  statusText: string;
}

const StatusPillOfframpChargeManagement: React.FC<
  StatusPillOfframpChargeManagementProps
> = ({ statusText }) => {
  return <DataPill value={statusText} label={statusText} />;
};

export default StatusPillOfframpChargeManagement;
